import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Progressbar } from "../Progressbar/Progressbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquare, faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import "./Onboarding-4.css";
import { useOnboarding } from "../contexts/OnboardingContext";
import { toast } from "react-toastify";

export const Onboarding4 = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(3);
  const totalSteps = 4;
  const { setOnboardingData } = useOnboarding();
  const [selectedTask, setSelectedTask] = useState(null);

  // Function to handle gender option selection (single-select toggle)
  const handleCheckboxChange = (taskId) => {
    if (selectedTask === taskId) {
      setSelectedTask(null);
    } else {
      setSelectedTask(taskId);
    }
  };

  // Gender options with emoji labels for clarity and accessibility
  const tasks = [
    { id: "task1", label: "👨 Male", value: "Male" },
    { id: "task2", label: "👩 Female", value: "Female" },
    { id: "task3", label: "🌈 Non-Binary", value: "Non-Binary" },
    { id: "task4", label: "👤 Other", value: "Other" },
    { id: "task5", label: "🙅 Prefer Not to Say", value: "prefer_not_to_say" },
  ];

  // Function triggered when the user clicks "Continue"
  const goToNextPage = () => {
    if (!selectedTask) {
      toast.warn("Please select an option before continuing.");
      return;
    }

    const selectedValue = tasks.find((task) => task.id === selectedTask)?.value;
    setOnboardingData((prev) => ({ ...prev, gender: selectedValue }));

    if (step < totalSteps) {
      setStep(step + 1);
      navigate("/Onboarding-Header3");
    }
  };

  return (
    <div className="onboarding4-page-wrapper">
      {/* Top Navigation / Glassmorphic Back button */}
      <button
        type="button"
        className="onboarding4-back-btn"
        onClick={() => navigate(-1)}
        aria-label="Go Back"
      >
        <span className="onboarding4-back-arrow" aria-hidden="true">
          &larr;
        </span>
        <span className="onboarding4-back-label">Back</span>
      </button>

      {/* Main Content Container (Centered horizontally & vertically) */}
      <div className="onboarding4-main-card">
        {/* Progress Bar Container */}
        <div className="onboarding4-progress-wrapper">
          <Progressbar step={step} totalSteps={totalSteps} />
        </div>

        {/* Title Header */}
        <div className="onboarding4-heading-group">
          <h1 className="onboarding4-page-title">
            How would you describe your gender?
          </h1>
          <p className="onboarding4-page-subtitle">
            Select the option that best describes you.
          </p>
        </div>

        {/* Gender Options */}
        <div className="onboarding4-checklist">
          {tasks.map((task) => {
            const isSelected = selectedTask === task.id;

            return (
              <div
                key={task.id}
                className={`onboarding4-card ${isSelected ? "selected" : ""}`}
                onClick={() => handleCheckboxChange(task.id)}
                role="radio"
                aria-checked={isSelected}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === " " || e.key === "Enter") {
                    e.preventDefault();
                    handleCheckboxChange(task.id);
                  }
                }}
              >
                <span className="onboarding4-card-label">{task.label}</span>
                <FontAwesomeIcon
                  className={`onboarding4-check-icon ${
                    isSelected ? "icon-selected" : "icon-unselected"
                  }`}
                  icon={isSelected ? faSquareCheck : faSquare}
                />
              </div>
            );
          })}
        </div>

        {/* Continue Action Button */}
        <button
          type="button"
          className="onboarding4-continue-btn"
          onClick={goToNextPage}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default Onboarding4;
